<template>
  <div>
    <section style="margin-right: 20px; margin-top: 10px">
      <div class="box box-danger">
        <div class="box-header d-flex align-items-center">
          <h3
            class="box-title"
            style="display: inline-block; margin-right: 5px"
          >
            Current User:
            <span v-if="currUser">{{ currUser.name }}</span>
          </h3>
          <button class="btn btn-default align-middle" @click="refreshData">
            <i class="fa fa-refresh"></i>
          </button>
        </div>
        <div class="box-body">
          <div class="nav-tabs-custom">
            <div class="tab-content">
              <div class="tab-pane active" id="tab_1">
                <h4>Institutions</h4>
                <ul class="list-group">
                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                    v-for="(inst, index) in assocInst"
                    :key="index"
                    :style="{
                      backgroundColor: inst.isSelected
                        ? 'lightblue'
                        : 'transparent',
                    }"
                  >
                    <div>
                      <span class="font-weight-bold">{{ inst.name }}</span>
                    </div>
                    <div>
                      <button
                        class="btn btn-sm"
                        @click.prevent="removeInstitution(index)"
                      >
                        Remove
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      tableRef: null,
      tableId:
        "ID" + Math.floor(Math.random() * (1000 - 1 + 1)) + 1 + Date.now(),
      tableColumns: [
        {
          data: "scheduler",
          title: "Scheduled By",
          type: "string",
          render: null,
        },
        {
          data: "startDate",
          title: "Start Date",
          type: "string",
          render: function (data, type, row) {
            return new Date(data).toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
          },
        },
        {
          data: "schedulePeriod",
          title: "Schedule Period",
          type: "Date",
          render: null,
        },
        {
          data: "nextDateTrigger",
          title: "Next Schedule Date",
          type: "Date",
          render: function (data, type, row) {
            return new Date(data).toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
          },
        },
        {
          data: "partnerType",
          title: "Partner Type",
          type: "string",
          render: null,
        },
        {
          data: "email",
          title: "Receiver Email",
          type: "string",
          render: null,
        },
        {
          data: "selectedPartyName",
          title: "Instituion Name",
          type: "string",
          render: null,
        },
      ],
      isLoading: false,
      isError: false,
      partner: "",
      assocInst: [],
    };
  },
  components: {},
  computed: {
    ...mapGetters("login", ["loggedInUser"]),
    ...mapGetters("admin", ["currUser", "allOrgs"]),
  },
  mounted() {
    this.refreshData();
  },
  watch: {
    currUser: {
      handler: function (val, oldVal) {
        if (val) {
          // console.log("currUser changed");
          this.refreshData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    refreshData() {
      // console.log(this.currUser);
      if (!this.currUser) return;
      this.currUser.assocParties = [];
      this.assocInst = [];
      if (this.currUser.associatedPartyIds) {
        this.currUser.associatedPartyIds.split(",").forEach((id) => {
          let org = this.allOrgs.find((o) => o.partyId == id);
          if (org) {
            // console.log(org);
            this.assocInst.push(org);
          }
        });
      }
    },
    removeInstitution(index) {
      const inst = this.assocInst[index];
      // console.log("remove ", inst);
      this.$store
        .dispatch("users/remove_assoc", {
          username: this.currUser.username,
          partyId: inst.partyId,
        })
        .then((res) => {
          // console.log(res);
          if (res.status == 200) {
            this.$store.dispatch("users/getLibrarians");
          }
        });
    },
  },
};
</script>

<style scoped></style>

<style>
.dataTables_wrapper .dataTables_paginate .paginate_button {
  margin-left: 5px;
  margin-right: 5px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/paywall/usage/AssociateOrgsPanel.vue